// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {import('../../auth/store/state').Account} Account
 */

/**
 * @typedef {Object} ChatRoom
 * @property {string} id
 * @property {string} title
 * @property {Account} createdBy
 * @property {Account[]} participants
 * @property {ChatMessage} lastMessage
 * @property {number} unseenMessages
 */

/**
 * @typedef {Object} ChatMessage
 * @property {string} id
 * @property {number} createdAt sending if null
 * @property {Account} createdBy
 * @property {string} room
 * @property {string} text
 * @property {string} media
 * @property {boolean} [failed] failed to send if set
 */

const state = {
  /** @type {ChatRoom[]} */
  rooms: [],
  /** @type {import('rxjs').Subscription} */
  roomsSub: null,
  /**
   * chat messages grouped by room id
   * @type {Object.<string,ChatMessage[]>}
   **/
  messages: {},
  /** @type {import('rxjs').Subscription} */
  messagesSub: null
};

export default state;

/**
 * @param {state} state
 * @returns {number}
 */
export function unreadMessages (state) {
  return state.rooms.reduce((sum, r) => sum + r.unseenMessages, 0);
}
